(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3456],{

/***/ 73456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Demo; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/NavigationBrand/index.ts + 3 modules
var NavigationBrand = __webpack_require__(22761);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 3 modules
var DemoForm = __webpack_require__(98960);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/index.ts

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/index.ts

FormSubmitMessage/* FormSubmitMessage.displayName */.f.displayName = "FormSubmitMessage";

// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Demo/components/AlreadyHaveAWorkspace/AlreadyHaveAWorkspace.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var LINK_TEXT = "Explore what you can do with Twilio Segment";

var AlreadyHaveAWorkspace = function AlreadyHaveAWorkspace() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var workspaceLink = (0,getAbsoluteUrl/* default */.Z)("/recipes/", pageConfig);
  var message = {
    heading: "Already have a workspace?",
    description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, {
      onClick: function onClick() {
        return (0,scripts/* trackButtonClick */.kO)({
          buttonText: LINK_TEXT,
          buttonId: "Recipe",
          targetUrl: workspaceLink
        });
      },
      href: workspaceLink,
      children: LINK_TEXT
    })
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, _objectSpread({
      form: "demo",
      status: "success",
      "data-hook": "demo-already-hava-a-workspace-message"
    }, message))
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex9q0na1"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ex9q0na0"
} : 0)( true ? {
  name: "2294y0",
  styles: "color:inherit;cursor:pointer"
} : 0);

/* harmony default export */ var AlreadyHaveAWorkspace_AlreadyHaveAWorkspace = (AlreadyHaveAWorkspace);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 258 modules
var Company = __webpack_require__(13922);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ./src/views/Demo/components/LogoSection/LogoSection.tsx


function LogoSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var logosCopy = {
  heading: "You're in great company",
  description: "Join 25,000+ companies who are using Segment to power world-class customer experiences."
};

var LogoSection = function LogoSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
        variant: "h3",
        children: logosCopy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
        children: logosCopy.description
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoGrid, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* BoxLogo */.R52, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* RitualLogo */.QVK, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* IntuitLogo */.M1u, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* DominosLogo */.MYS, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* AllerganLogo */.Rko, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* VmwareLogo */.wDo, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* LevisLogo */._dL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* InstacartLogo */.MyN, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* IbmLogo */.D64, {})]
    })]
  });
};

var LogoGrid = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ek7x2kc0"
} : 0)( true ? {
  name: "1ehn2d6",
  styles: "align-items:center;display:grid;gap:32px;grid-template-columns:1fr 1fr 1fr;justify-items:center;padding:48px 0;svg{height:32px;}"
} : 0);

/* harmony default export */ var LogoSection_LogoSection = (LogoSection);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/useModal.ts
var useModal = __webpack_require__(95290);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/index.ts + 2 modules
var Modal = __webpack_require__(33400);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/Loader.tsx + 1 modules
var Loader = __webpack_require__(59154);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/tracking/useTrustArc/index.ts + 2 modules
var useTrustArc = __webpack_require__(53550);
// EXTERNAL MODULE: ../../libs/utils/usePortal/usePortal.ts
var usePortal = __webpack_require__(75290);
;// CONCATENATED MODULE: ./src/views/Demo/components/WantATour/ProductTourModal/ProductTourModal.tsx



function ProductTourModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductTourModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductTourModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductTourModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function ProductTourModal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var ProductTourModal = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var opened = _ref.opened,
      getControlCloseProps = _ref.getControlCloseProps;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var modalsRoot = (0,usePortal/* default */.Z)("modals-root");

  var _useState = (0,react.useState)(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var trustArcHeightOffset = (0,useTrustArc/* useTrustArcHeightOffset */.c)();
  (0,react.useEffect)(function () {
    if (opened) {
      setLoading(true);
    }
  }, [opened]);
  return opened && /*#__PURE__*/(0,react_dom.createPortal)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* default */.ZP, {
    customZIndex: 999,
    fullScreen: true,
    fullScreenBottomOffset: trustArcHeightOffset,
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* Head */.Fb, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
        alt: "Segment Logo"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledClearIcon, ProductTourModal_objectSpread({
        color: theme.palette.twilio.gray[100],
        size: "large"
      }, getControlCloseProps()))]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledModalBody, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IframeWrapper, {
        children: [loading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLoader, {
          size: "xlarge"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIframe, {
          title: "Product Tour",
          src: "https://capture.navattic.com/cllviu8af011i08meaa43dxbo",
          allow: "fullscreen",
          onLoad: function onLoad() {
            return setLoading(false);
          }
        })]
      })
    })]
  }), modalsRoot) || null;
});

var StyledClearIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Common/* ClearIcon */.Rk,  true ? {
  target: "evqp7sc4"
} : 0)( true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0);

var StyledIframe = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("iframe",  true ? {
  target: "evqp7sc3"
} : 0)( true ? {
  name: "12vnig7",
  styles: "border:none;width:100%;height:100%"
} : 0);

var IframeWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqp7sc2"
} : 0)( true ? {
  name: "zxsb69",
  styles: "position:relative;width:100%;height:100%"
} : 0);

var StyledModalBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal/* Body */.uT,  true ? {
  target: "evqp7sc1"
} : 0)( true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0);

var StyledLoader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Loader/* Loader */.a,  true ? {
  target: "evqp7sc0"
} : 0)( true ? {
  name: "utdw92",
  styles: "position:absolute;top:20%;left:50%;transform:translate(-50%, -50%)"
} : 0);

/* harmony default export */ var ProductTourModal_ProductTourModal = (ProductTourModal);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/Button.tsx
var Button = __webpack_require__(62073);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/FormSubmitAction.views.tsx
var FormSubmitAction_views = __webpack_require__(39466);
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/Modal.views.tsx
var Modal_views = __webpack_require__(94441);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ./src/views/Demo/components/WantATour/ImageCta/Modal.views.tsx


function Modal_views_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var BackgroundImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e15jvf3e5"
} : 0)( true ? {
  name: "zwhgcb",
  styles: "width:100%;min-width:340px;border-radius:8px"
} : 0);
var Modal_views_Modal = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal_views/* Wrapper */.im,  true ? {
  target: "e15jvf3e4"
} : 0)("position:absolute;z-index:1;top:calc(50% - 105px);left:calc(50% - 145px);", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{top:calc(50% - 105px);left:calc(50% - 179px);}" + ( true ? "" : 0));
var ModalHead = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal_views/* ModalHead */.Io,  true ? {
  target: "e15jvf3e3"
} : 0)( true ? {
  name: "f7ay7b",
  styles: "justify-content:center"
} : 0);
var ModalBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal_views/* ModalBody */.fe,  true ? {
  target: "e15jvf3e2"
} : 0)( true ? {
  name: "18edp2f",
  styles: "padding-top:0px;text-align:center"
} : 0);
var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "e15jvf3e1"
} : 0)("margin-top:0px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{line-height:21px;}" + ( true ? "" : 0));
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15jvf3e0"
} : 0)( true ? {
  name: "1d0nbku",
  styles: "margin-top:24px"
} : 0);
// EXTERNAL MODULE: ./src/views/Demo/components/WantATour/ImageCta/assets/ImageCtaWrapper.png
var ImageCtaWrapper = __webpack_require__(34140);
var ImageCtaWrapper_default = /*#__PURE__*/__webpack_require__.n(ImageCtaWrapper);
;// CONCATENATED MODULE: ./src/views/Demo/components/WantATour/ImageCta/MobileImageCta.tsx





function MobileImageCta_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MobileImageCta_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileImageCta_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileImageCta_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function MobileImageCta_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var copy = {
  description: "Explore this interactive demo to see how Segment helps teams collect, clean, and activate data.",
  buttonText: "Send me the tour"
};
var thankYouMessage = {
  heading: "Check your inbox to begin the product tour.",
  description: "For the best experience, we recommend viewing this demo on a desktop device."
};
var MobileImageCta = function MobileImageCta() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useState = (0,react.useState)(false),
      tourSent = _useState[0],
      setTourSent = _useState[1];

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      completedFormData = _useContext.completedFormData;

  var onClickHandler = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,scripts/* trackEmailCaptureForm */.Ak)(MobileImageCta_objectSpread({
              customFormIdentifier: "site-producttour-ungate"
            }, completedFormData));

          case 2:
            setTourSent(true);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [completedFormData]);

  var thankYouMessageComponent = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFormSubmitMessage, MobileImageCta_objectSpread({
    form: "demo",
    status: "success",
    "data-hook": "demo-product-tour-sent-message"
  }, thankYouMessage));

  var cta = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileImageCta_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundImage, {
      src: (ImageCtaWrapper_default()),
      alt: "Image Wrapper"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal_views_Modal, {
      role: "dialog",
      elevation: 1,
      maxWidth: 290,
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalHead, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalBody, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
          variant: "textRegularSmall",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
            variant: "filled",
            color: "primary",
            size: "medium",
            onClick: onClickHandler,
            children: copy.buttonText
          })
        })]
      })]
    })]
  });

  return tourSent ? thankYouMessageComponent : cta;
};

var StyledFormSubmitMessage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FormSubmitMessage/* FormSubmitMessage */.f,  true ? {
  target: "eg2a9th1"
} : 0)(FormSubmitAction_views/* Header */.h4, "{grid-template-columns:inherit;}" + ( true ? "" : 0));

var MobileImageCta_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg2a9th0"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
;// CONCATENATED MODULE: ./src/views/Demo/components/WantATour/ImageCta/DesktopImageCta.tsx




function DesktopImageCta_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var DesktopImageCta_copy = {
  description: "Explore this interactive demo to see how Segment helps teams collect, clean, and activate data.",
  buttonText: "Start the tour"
};
var DesktopImageCta = function DesktopImageCta(_ref) {
  var onClick = _ref.onClick;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var onClickHandler = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: DesktopImageCta_copy.buttonText,
                buttonId: "Product tour"
              });

            case 2:
              onClick(e);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onClick]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopImageCta_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundImage, {
      alt: "",
      src: (ImageCtaWrapper_default())
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal_views_Modal, {
      role: "dialog",
      elevation: 1,
      maxWidth: 360,
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalHead, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalBody, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
          variant: "pSmall",
          children: DesktopImageCta_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
            variant: "filled",
            color: "primary",
            size: "large",
            onClick: onClickHandler,
            children: DesktopImageCta_copy.buttonText
          })
        })]
      })]
    })]
  });
};

var DesktopImageCta_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epkhdri0"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
;// CONCATENATED MODULE: ./src/views/Demo/components/WantATour/WantATour.tsx




function WantATour_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WantATour_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WantATour_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WantATour_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function WantATour_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var HEADING = "Want a tour of Twilio Segment?";

var WantATour = function WantATour() {
  var modalRef = (0,react.useRef)(null);
  var modalOpenState = (0,react.useState)(false);

  var _modalOpenState = (0,slicedToArray/* default */.Z)(modalOpenState, 1),
      opened = _modalOpenState[0];

  var _useModal = (0,useModal/* default */.Z)(modalRef, modalOpenState),
      getControlOpenProps = _useModal.getControlOpenProps,
      getControlCloseProps = _useModal.getControlCloseProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
      variant: "h3",
      children: HEADING
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileImageCta, {})
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopImageCta, WantATour_objectSpread({}, getControlOpenProps()))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductTourModal_ProductTourModal, {
      opened: opened,
      getControlCloseProps: getControlCloseProps,
      ref: modalRef
    })]
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e17sdpyb0"
} : 0)( true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0);

/* harmony default export */ var WantATour_WantATour = (WantATour);
;// CONCATENATED MODULE: ./src/views/Demo/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var Hero = function Hero(_ref) {
  var beginsWithLeadEnrichmentForm = _ref.beginsWithLeadEnrichmentForm;

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      completedFormData = _useContext.completedFormData;

  var copy = {
    overline: "Get a demo",
    heading: beginsWithLeadEnrichmentForm ? "Help us get you to the right starting point" : "See what Segment can do for you",
    description: beginsWithLeadEnrichmentForm ? "Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment." : "Tell us a little about yourself and we'll connect you with a Segment expert who can share more about the product and answer any questions you have."
  }; // Copy that goes before the form and is hidden after form submission

  var beforeContent = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [!beginsWithLeadEnrichmentForm && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
      tag: "h1",
      variant: "h5",
      children: copy.overline
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
      variant: "h1",
      tag: "h2",
      children: copy.heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
      variant: "pMedium",
      tag: "p",
      children: copy.description
    })]
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [beginsWithLeadEnrichmentForm ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
          before: beforeContent
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
          before: beforeContent
        }), completedFormData && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlreadyHaveAWorkspace_AlreadyHaveAWorkspace, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContents, {
        children: completedFormData ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WantATour_WantATour, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoSection_LogoSection, {})
      })]
    })
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e14bu67y1"
} : 0)("align-items:flex-start;", recipes_Hero/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:1fr 1fr;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xl");
}, "{gap:200px;}}" + ( true ? "" : 0));

var StyledContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "e14bu67y0"
} : 0)( true ? {
  name: "124df4c",
  styles: "justify-items:stretch;width:auto"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ./src/views/Demo/assets/OgDemo.jpeg
var OgDemo = __webpack_require__(39513);
var OgDemo_default = /*#__PURE__*/__webpack_require__.n(OgDemo);
;// CONCATENATED MODULE: ./src/views/Demo/Demo.tsx












var DemoView = function DemoView(_ref) {
  var _ref$beginsWithLeadEn = _ref.beginsWithLeadEnrichmentForm,
      beginsWithLeadEnrichmentForm = _ref$beginsWithLeadEn === void 0 ? false : _ref$beginsWithLeadEn;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(demo/* DemoProvider */.Y, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
        pageTitle: "Request a Product Demo From Our Sales Team | Twilio Segment",
        pageDescription: "Twilio Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data.",
        pageOG: (OgDemo_default()),
        themeColor: theme.palette.twilio.gray[10],
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
            beginsWithLeadEnrichmentForm: beginsWithLeadEnrichmentForm
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1u6ksev0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Demo = (DemoView);

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 95290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81333);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27866);



var _excluded = ["onClick"],
    _excluded2 = ["onClick"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DEFAULT_OPTIONS = {
  closeOnOverlayClick: true
};
var DEFAULT_EVENTS = ["mousedown", "touchstart"];

var useModal = function useModal(menuRef, _ref, options) {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, 2),
      setOpened = _ref2[1];

  var settings = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }, [options]);

  var getControlOpenProps = function getControlOpenProps() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick = _ref3.onClick,
        rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded);

    return _objectSpread({
      onClick: function onClick(event) {
        setOpened(true);
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
      }
    }, rest);
  };

  var getControlCloseProps = function getControlCloseProps() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick2 = _ref4.onClick,
        rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref4, _excluded2);

    return _objectSpread({
      'aria-label': "Close the modal",
      onClick: function onClick(event) {
        setOpened(false);
        _onClick2 === null || _onClick2 === void 0 ? void 0 : _onClick2(event);
      }
    }, rest);
  };

  (0,react_use__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(menuRef, function () {
    if (settings.closeOnOverlayClick) {
      setOpened(false);
    }
  }, settings.closeOnOverlayClick ? DEFAULT_EVENTS : []);
  return {
    getControlOpenProps: getControlOpenProps,
    getControlCloseProps: getControlCloseProps
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useModal);

/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 22761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavigationBrand_NavigationBrand; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/MobileNavigation.tsx








var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/DesktopNavigation.tsx







var DesktopNavigation_MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_DesktopNavigation = (DesktopNavigation_MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/NavigationBrand.tsx






var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
/* harmony default export */ var NavigationBrand_NavigationBrand = (NavigationBrand);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/index.ts


/***/ }),

/***/ 39513:
/***/ (function(module) {

module.exports = "/_next/static/images/OgDemo-d7b3c7db5fe8313523e98ed96fa0d6d6.jpeg";

/***/ }),

/***/ 34140:
/***/ (function(module) {

module.exports = "/_next/static/images/ImageCtaWrapper-835bd723f22e3e83e92382ce382aac31.png";

/***/ })

}]);